
export const NoSprite = (
  <path d="M0-37.5A37.54,37.54,0,0,0-37.5,0,37.54,37.54,0,0,0,0,37.5,37.54,37.54,0,0,0,37.5,0,37.54,37.54,0,0,0,0-37.5ZM32.5,0a32.36,32.36,0,0,1-7.84,21.13L-21.13-24.66A32.36,32.36,0,0,1,0-32.5,32.54,32.54,0,0,1,32.5,0Zm-65,0a32.36,32.36,0,0,1,7.84-21.13L21.13,24.66A32.36,32.36,0,0,1,0,32.5,32.54,32.54,0,0,1-32.5,0Z" fill="#ff1d25" />
);
